import React from 'react'
import { NavLink } from 'react-router-dom'
import startCase from 'lodash/startCase'

export const DashboardOrders = props => {
    const { data, loading } = props

    const currencySymbols = {
        GBP: '£',
        USD: '$',
        EUR: '€',
    }

    const formatAsCurrency = (price = 0, currency = 'GBP') => {
        return `${currencySymbols[currency]}${(price / 100).toFixed(2)}`
    }

    return (
        <div className="dashboard-table">
            <div
                className="table-column"
                style={{
                    color: '#338CE4',
                }}
            >
                <div className="header">Most recent orders</div>
                <div className="view-all">
                    <NavLink to="/orders" activeClassName="active">
                        View All
                    </NavLink>
                </div>
            </div>
            {loading ? (
                <div className="table-column">Orders Loading...</div>
            ) : (
                <div>
                    {!data || data <= 1 ? (
                        <div className="table-column">No results found</div>
                    ) : (
                        <div>
                            <div
                                className="table-column"
                                style={{
                                    color: '#212529',
                                }}
                            >
                                <div style={{ width: '25%' }}>Order Reference</div>
                                <div style={{ width: '25%' }}>Email</div>
                                <div style={{ width: '15%' }}>Delivery Surname</div>
                                <div style={{ width: '12%' }}>Total (inc. tax)</div>
                                <div style={{ width: '12%' }}>Total (exc. tax)</div>
                                <div style={{ width: '11%' }}>Status</div>
                            </div>
                            {data.map(order => (
                                <div key={order.id} className="table-column">
                                    <div style={{ color: '#338CE4', width: '25%' }}>
                                        <NavLink
                                            to={`/orders/${order.id}`}
                                            activeClassName="active"
                                        >
                                            {order.reference}
                                        </NavLink>
                                    </div>
                                    <div style={{ width: '25%' }}>{order.email}</div>
                                    <div style={{ width: '15%' }}>
                                        {order.deliveryAddress?.surname}
                                    </div>
                                    <div style={{ width: '12%' }}>
                                        {formatAsCurrency(
                                            order.totalIncTaxAfterDiscount,
                                            order.currency
                                        )}
                                    </div>
                                    <div style={{ width: '12%' }}>
                                        {formatAsCurrency(
                                            order.totalExcTaxAfterDiscount,
                                            order.currency
                                        )}
                                    </div>
                                    <div style={{ width: '11%' }}>{startCase(order.status)}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
